module.exports = __webpack_public_path__ + "img/30.423de1fe.jpg";